﻿module SafeStack.Client.Notification

open Elmish
open global.Elmish.Toastr 
open Fable.React

module Extentions = 
    let escapeHtml escape (msg: Toastr.ToastrMsg<_>) = 
        let options = msg.Options
        options.escapeHtml <- escape
        msg

    let closeOnHover close (msg: Toastr.ToastrMsg<_>) = 
        let options = msg.Options
        options.closeOnHover <- close
        msg

    let stayOpen (msg: Toastr.ToastrMsg<_>) = 
        let options = msg.Options
        options.timeout <- 0
        options.extendedTimeout <- 0
        msg

    let tapToDismiss tapToDismiss (msg: Toastr.ToastrMsg<_>) = 
        let options = msg.Options
        options.tapToDismiss <- tapToDismiss
        msg

let private buildToast msg onHideMsg =
    Toastr.message msg
    //|> Toastr.title "Shiny title"
    |> Toastr.position TopRight
    |> Toastr.timeout 10000
    |> Extentions.escapeHtml true
    |> Extentions.closeOnHover false
    //|> Toastr.withProgressBar
    |> Toastr.hideEasing Easing.Swing
    |> Toastr.showCloseButton
    |> Toastr.closeButtonClicked onHideMsg
    |> Toastr.onClick onHideMsg 

let success msg onHideMsg = buildToast msg onHideMsg |> Toastr.success
let info msg onHideMsg = buildToast msg onHideMsg |> Toastr.info
let error msg onHideMsg = buildToast msg onHideMsg |> Toastr.error
let warning msg onHideMsg = buildToast msg onHideMsg |> Toastr.warning
let openInfo msg onHideMsg = buildToast msg onHideMsg |> Extentions.stayOpen |> Toastr.info

let private buildToastWithContent showForXSeconds onCloseMsg msgContent =
    let str = Fable.React.ReactDomBindings.ReactDomServer.renderToStaticMarkup (div [] msgContent)
    Toastr.message str
    |> Toastr.position TopRight
    |> Toastr.timeout (showForXSeconds * 1000)
    |> Extentions.escapeHtml false
    |> Extentions.closeOnHover false
    |> Extentions.tapToDismiss false
    //|> Toastr.withProgressBar
    |> Toastr.hideEasing Easing.Swing
    |> Toastr.showCloseButton
    |> Toastr.closeButtonClicked onCloseMsg

let successWithContent showForXSeconds onCloseMsg msgContent = buildToastWithContent showForXSeconds onCloseMsg msgContent |> Toastr.success
let infoWithContent showForXSeconds onCloseMsg msgContent = buildToastWithContent showForXSeconds onCloseMsg msgContent |> Toastr.info
let errorWithContent showForXSeconds onCloseMsg msgContent = buildToastWithContent showForXSeconds onCloseMsg msgContent |> Toastr.error
let warningWithContent showForXSeconds onCloseMsg msgContent = buildToastWithContent showForXSeconds onCloseMsg msgContent |> Toastr.warning